import { get, post, put, deletes } from './http'

//字典相关
export const sysdicttree = sysdicttree => get('/sys/dict/tree/' + sysdicttree)
export const sysdictarray = sysdictarray => get('/sys/dict/array/' + sysdictarray)
export const authregister = authregister => post('/auth/register', authregister)
export const sysconfbanner = sysconfbanner => post('sys/conf/banner', sysconfbanner)
export const sysconfkeys = sysconfkeys => post('/sys/conf/keys', sysconfkeys)
//登录
export const authwebsite = authwebsite => post('/auth/website', authwebsite);
export const authcode = authcode => post('/auth/code', authcode)
export const personinfo = personinfo => get('/person/info', personinfo)
export const personbalancelogpage = personbalancelogpage => get('/person/balance/log/page', personbalancelogpage)
export const sysconfregion = sysconfregion => get('/sys/conf/region', sysconfregion)

//文件上传
export const docpost = docpost => post('/doc/', docpost)
export const docput = docput => put('/doc/', docput)
export const docinfo = docinfo => get('/doc/' + docinfo)
export const docde = docde => deletes('/doc/' + docde)
export const docmanage = docmanage => get('/doc/manage', docmanage)
export const docpage = docpage => get('/doc/page', docpage)
export const docdownloadpage = docdownloadpage => get('/doc/download', docdownloadpage)

//积分充值
export const personrechargeorderpay = personrechargeorderpay => post('/person/recharge/order/pay', personrechargeorderpay)
export const docdownload = docdownload => post('/doc/download', docdownload)

//服务商
export const servicepost = servicepost => post('/service/', servicepost)
export const servicepage = servicepage => get('/service/page', servicepage)
export const serviceself = serviceself => get('/service/self', serviceself)
export const serviceput = serviceput => put('/service/', serviceput)
export const servicebuy = servicebuy => post('/service/buy', servicebuy)
export const serviceinfo = serviceinfo => get('/service/' + serviceinfo)

//活动
export const salonpost = salonpost => post('/salon/', salonpost)
export const salonput = salonput => put('/salon/', salonput)
export const salonjoin = salonjoin => post('/salon/join', salonjoin)
export const salonpage = salonpage => get('/salon/page', salonpage)
export const salonmanage = salonmanage => get('/salon/manage', salonmanage)
export const saloninfo = saloninfo => get('/salon/' + saloninfo)
export const salonde = salonde => deletes('/salon/' + salonde)
export const salonjoinpage = salonjoinpage => get('/salon/join', salonjoinpage)
export const saloncancel = saloncancel => post('/salon/cancel', saloncancel)


//技术需求
export const demandpost = demandpost => post('/demand/', demandpost)
export const demandput = demandput => put('/demand/', demandput)
export const demandinfo = demandinfo => get('/demand/' + demandinfo)
export const demandpage = demandpage => get('/demand/page', demandpage)
export const demandsend = demandsend => post('/demand/send', demandsend)
export const demandbuy = demandbuy => post('/demand/buy', demandbuy)
export const demandmanage = demandmanage => get('/demand/manage', demandmanage)
export const demandde = demandde => deletes('/demand/' + demandde)
export const demandsendpage = demandsendpage => get('/demand/send', demandsendpage)
export const demandcancel = demandcancel => post('/demand/cancel', demandcancel)
export const demandmember = demandmember => get('/demand/member', demandmember)
export const demandchoice = demandchoice => post('/demand/choice', demandchoice)
export const demandmismatching = demandmismatching => post('/demand/mismatching', demandmismatching)
export const demandexpert = demandexpert => post('/demand/expert', demandexpert)
//技术大咖新增
export const expertpost = expertpost => post('/expert/', expertpost)
export const expertpage = expertpage => get('/expert/page', expertpage)
export const expertself = expertself => get('/expert/self', expertself)
export const expertput = expertput => put('/expert/', expertput)
export const expertconsultsubmit = expertconsultsubmit => post('/expert/consult/submit', expertconsultsubmit)
export const expertinfo = expertinfo => get('/expert/' + expertinfo)
export const personrechargeorderpage = personrechargeorderpage => get('/person/recharge/order/page', personrechargeorderpage)
export const personrechargeorder = personrechargeorder => get('/person/recharge/order/' + personrechargeorder)
export const expertsend = expertsend => post('/expert/send', expertsend)

export const expertauthsubmit = expertauthsubmit => post('/expert/auth/submit', expertauthsubmit)
export const expertauthself = expertauthself => get('/expert/auth/self')


//我的申请
export const expertselflist = expertselflist => get('/expert/mine', expertselflist)

//我得审核
export const expertmanage = expertmanage => get('/expert/manage', expertmanage)

//审核申请
export const expertauth = expertauth => post('/expert/auth', expertauth)


export const oauthloginresult = oauthloginresult => get('oauth/login/result', oauthloginresult)

export const expertconsultself = expertconsultself => get('/expert/consult/self', expertconsultself)
export const expertconsultover = expertconsultover => post('/expert/consult/over', expertconsultover)

export const fieldget = fieldget => get('/sys/dict/field', fieldget)


export const techpage = techpage => get('/tech/page', techpage)
export const tech = tech => get('/tech/' + tech)
export const techbuy = techbuy => post('/tech/buy', techbuy)
export const techmanage = techmanage => get('/tech/manage', techmanage)
export const techpost = techpost => post('/tech/', techpost)
export const techremove = techremove => post('techremove', techremove)
export const techput = techput => put('/tech/', techput)
export const techself = techself => get('/tech/self', techself)

export const sysconfnews =sysconfnews =>get('sys/conf/news',sysconfnews)

export const newsinfo = newsinfo => get('sys/conf/news/' + newsinfo)



// WEBPACK FOOTER //
// ./src/request/api.js